module.exports = __webpack_public_path__ + "img/code.d40e1a13.png";